import { PatientTestEnum } from "requests";

export const TEST_NAME_TO_TITLE = {
  [PatientTestEnum.Heartworm]: "Heartworm",
  [PatientTestEnum.Fecal]: "Fecal",
  [PatientTestEnum.UrineAnalysis]: "Urine Analysis",
  [PatientTestEnum.FelvFiv]: "FeLV/FIV"
};
